export const isPointInsideElement = ({ x, y }: { x: number; y: number }, element: HTMLElement) => {
  const rect = element.getBoundingClientRect();

  return y >= rect.top && x >= rect.left && y <= rect.bottom && x <= rect.right;
};
